import styles from "./AuthorsMosaicFilters.module.scss";
import clsx from "clsx";
import SearchInput from "@/ui/posts-list/AlgoliaPostsMosaic/SearchInput";
import SearchStats from "@/ui/posts-list/AlgoliaPostsMosaic/SearchStats";

type Props = {
  className?: string;
};

const AuthorsMosaicFilters: React.FC<Props> = ({ className }) => {
  return (
    <div
      className={clsx(styles.filters, className)}
      data-content-name="authors-filters"
    >
      <SearchInput
        className={styles.search}
        data-content-piece="search-input"
      />
      <div className={styles.stats}>
        <SearchStats singular="author" plural="authors" />
      </div>
    </div>
  );
};

export default AuthorsMosaicFilters;
